<h1 class="h5 mb-0">Pixels/postbacks</h1>
<p class="text-muted">Manage third-party conversion tracking pixels and postback URLs.</p>

<div class="card shadow border-0">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped">
        <thead class="table-light">
        <tr>
          <th>Goal</th>
          <th>Type</th>
          <th>Offer</th>
          <th>Code/URL</th>
<!--          <th>Added</th>-->
<!--          <th>Last Modified</th>-->
          <th>Status</th>
<!--          <th>Actions</th>-->
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let postback of postbacks">
          <td class="align-middle">{{ postback.goal }}</td>
          <td class="align-middle">Postback</td>
          <td class="align-middle">
            <span *ngFor="let offer of postback.offers" class="me-2">
              <a [routerLink]="['/offer', offer.id]" class="text-decoration-none">{{ offer }}</a>
              <a [routerLink]="['/offer', offer.id]" class="ms-1"><i class="bi bi-box-arrow-up-right"></i></a>
            </span>
          </td>
          <td class="align-middle">
            <input type="text" [value]="postback.url" readonly class="form-control w-100 code">
          </td>
<!--          <td class="align-middle">{{ postback.createdAt | date: 'yyyy-MM-dd' }}</td>-->
<!--          <td class="align-middle">{{ postback.updatedAt | date: 'yyyy-MM-dd' }}</td>-->
          <td class="align-middle">
            <i *ngIf="postback.enabled" class="bi bi-check-circle-fill text-success"></i>
            <i *ngIf="!postback.enabled" class="bi bi-x-circle-fill text-danger"></i>
          </td>
<!--          <td class="align-middle">-->
<!--            <button class="btn btn-sm btn-primary fw-bold">-->
<!--              <i class="bi bi-bar-chart-line"></i> Stats-->
<!--            </button>-->
<!--          </td>-->
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
